var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":"","left-text":"返回"},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"cart","size":"30"},on:{"click":function($event){return _vm.goIndex()}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }